<template>
  <div>
    Connexion en cours
  </div>
</template>

<script>

export default {
  name: 'SaveTokenFromSSOPage',
  components: {
  },

  data: () => ({
  }),

  props: {
  },

  methods: {
  },

  mounted() {
    if (this.$route && this.$route.query && this.$route.query.pseudo && this.$route.query.token) {
      window.localStorage.setItem('pseudo', this.$route.query.pseudo);
      window.localStorage.setItem('token', this.$route.query.token);
    } else {
      window.localStorage.removeItem('pseudo');
      window.localStorage.removeItem('token');
    }
    var daddy = window.self;
    daddy.opener = window.self;
    daddy.close();
  }
}
</script>

<style>
</style>